import isNode from 'detect-node';
import loadPost from './load-post.js';

const posts = {
  '2021-03-28-signed-new-contract': () => import('../components/posts/post-2021-03-28-signed-new-contract.js'),
  '2021-03-03-looking-for-contract': () => import('../components/posts/post-2021-03-03-looking-for-contract.js'),
  '2017-09-12-hi': () => import('../components/posts/post-2017-09-12-hi.js')
};

export default function (postName, callback = () => {}) {
  return (dispatch) => {
    posts[postName]().then(PostNs => {
      let Post;
      if(typeof PostNs.default == 'undefined') {
        Post = PostNs;
      } else {
        Post = PostNs.default;
      }
      dispatch(loadPost(postName, Post));
      callback(Post);
    });
  };
}
